// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag__zBLC4DEDPn{background:rgba(0,0,0,0);padding:0}`, "",{"version":3,"sources":["webpack://./src/components/hookForm/hookFormTagSelect/hookFormTagSelect.module.scss"],"names":[],"mappings":"AAAA,iBACE,wBAAA,CACA,SAAA","sourcesContent":[".tag {\n  background: transparent;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `tag__zBLC4DEDPn`
};
export default ___CSS_LOADER_EXPORT___;
